// video-carousel.js
(function() {
  'use strict';

  const VideoCarousel = {
    init: function() {
      this.initializeCarousels();
      this.initLazyVideos();
      this.initPlayButtons();
      this.setupEventListeners();
    },

    initLazyVideos: function() {
      const videos = document.querySelectorAll('video[data-video-element]');
      
      const loadVideo = (video) => {
        if (video.getAttribute('data-video-loaded')) return;
        
        const wrapper = video.closest('.video-wrapper');
        if (wrapper) wrapper.classList.add('is-loading');

        const sources = video.querySelectorAll('source[data-src]');
        sources.forEach(source => {
          if (source instanceof HTMLSourceElement) {
            source.src = source.getAttribute('data-src') || '';
          }
        });
        
        video.load();
        video.setAttribute('data-video-loaded', 'true');
        
        const onLoaded = () => {
          if (wrapper) wrapper.classList.remove('is-loading');
          video.currentTime = 0.1;
        };

        if (video.readyState >= 1) {
          onLoaded();
        } else {
          video.addEventListener('loadedmetadata', onLoaded, { once: true });
        }
      };

      // Cargar TODOS los videos de inmediato
      videos.forEach(v => {
        if (v instanceof HTMLVideoElement) {
          loadVideo(v);
        }
      });
    },

    initializeCarousels: function() {
      const carousels = document.querySelectorAll('.video-carousel-container');

      carousels.forEach((viewport) => {
        if (typeof EmblaCarousel === 'function') {
          const embla = EmblaCarousel(viewport, {
            align: 'start',
            loop: true,
            slidesToScroll: 1,
            containScroll: 'trimSnaps',
            dragFree: true // Añadir dragFree para mejor UX en móvil
          });
          viewport._embla = embla;
        }
      });

      this.setupCarouselNavigation();
    },

    setupCarouselNavigation: function() {
      const prevButtons = document.querySelectorAll('[data-carousel-prev]');
      const nextButtons = document.querySelectorAll('[data-carousel-next]');

      prevButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const wrapper = button.closest('.video-carousel-wrapper');
          if (!wrapper) return;
          const viewport = wrapper.querySelector('.video-carousel-container');
          if (viewport && viewport._embla) {
            viewport._embla.scrollPrev();
          }
        });
      });

      nextButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const wrapper = button.closest('.video-carousel-wrapper');
          if (!wrapper) return;
          const viewport = wrapper.querySelector('.video-carousel-container');
          if (viewport && viewport._embla) {
            viewport._embla.scrollNext();
          }
        });
      });
    },

    initPlayButtons: function() {
      // Limpiar listeners anteriores para evitar duplicados
      const existingPlayButtons = document.querySelectorAll('[data-toggle-play]');
      existingPlayButtons.forEach((button) => {
        if (button.parentNode) {
          const newButton = button.cloneNode(true);
          button.parentNode.replaceChild(newButton, button);
        }
      });

      const existingSoundButtons = document.querySelectorAll('[data-toggle-sound]');
      existingSoundButtons.forEach((button) => {
        if (button.parentNode) {
          const newButton = button.cloneNode(true);
          button.parentNode.replaceChild(newButton, button);
        }
      });

      const playButtons = document.querySelectorAll('[data-toggle-play]');
      const isDesktop = window.matchMedia('(min-width: 768px)').matches;

      playButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const videoWrapper = button.closest('.video-wrapper');
          if (!videoWrapper) return;

          const video = videoWrapper.querySelector('video[data-video-element]');
          const soundButton = videoWrapper.querySelector('[data-toggle-sound]');

          if (!video || !(video instanceof HTMLVideoElement)) return;

          // Si el video aún no tiene SRC (lazy load), forzar la carga antes de reproducir
          if (!video.getAttribute('data-video-loaded')) {
             const sources = video.querySelectorAll('source[data-src]');
             sources.forEach(source => source.src = source.getAttribute('data-src'));
             video.load();
             video.setAttribute('data-video-loaded', 'true');
             
             // Esperar a que cargue suficiente para reproducir
             video.addEventListener('canplay', () => {
                this.toggleVideoPlayPause(video, button, soundButton);
             }, { once: true });
             return;
          }

          if (!isDesktop) {
            this.toggleVideoPlayPause(video, button, soundButton);
          }
        });
      });

      // Agregar listener al overlay para pausar con click (solo en móvil)
      if (!isDesktop) {
        const overlays = document.querySelectorAll('.video-overlay');
        overlays.forEach((overlay) => {
          overlay.addEventListener('click', (e) => {
            // Solo si el click no fue en el play button o sound button
            const target = e.target;
            if (target instanceof HTMLElement) {
              if (target.closest('[data-toggle-play]') || target.closest('[data-toggle-sound]')) {
                return;
              }
            }

            e.preventDefault();
            e.stopPropagation();

            const videoWrapper = overlay.closest('.video-wrapper');
            if (!videoWrapper) return;

            const video = videoWrapper.querySelector('video[data-video-element]');
            const button = videoWrapper.querySelector('[data-toggle-play]');
            const soundButton = videoWrapper.querySelector('[data-toggle-sound]');

            if (!video || !button) return;

            // Solo pausar si el video está en reproducción
            if (!video.paused) {
              this.toggleVideoPlayPause(video, button, soundButton);
            }
          });
        });
      }

      // Manejar botón de sonido
      this.setupSoundButtons();

      // Hover para reproducir en escritorio
      this.setupHoverPlayback();
    },

    toggleVideoPlayPause: function(video, button, soundButton) {
      // Verificar si el video está siendo reproducido actualmente
      const isPlaying = !video.paused;
      
      if (isPlaying) {
        // Si está en reproducción, pausar
        video.pause();
        video.currentTime = 0;
        button.classList.remove('hidden');
        if (soundButton) {
          soundButton.classList.remove('visible');
        }
        return;
      }

      // Limpiar cualquier listener de ended anterior
      const onEndedHandler = video._onEndedHandler;
      if (onEndedHandler) {
        video.removeEventListener('ended', onEndedHandler);
        video._onEndedHandler = null;
      }

      // Intentar reproducir video
      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Ocultar el botón de play cuando el video se reproduce correctamente
            button.classList.add('hidden');
            // Mostrar botón de sonido cuando el video se reproduce
            if (soundButton) {
              soundButton.classList.add('visible');
            }

            // Agregar evento para cuando termina el video
            const onEnded = () => {
              button.classList.remove('hidden');
              video.currentTime = 0;
              video.pause();
              if (soundButton) {
                soundButton.classList.remove('visible');
              }
              video.removeEventListener('ended', onEnded);
              video._onEndedHandler = null;
            };

            // Guardar referencia al handler para poder limpiarlo
            video._onEndedHandler = onEnded;
            video.addEventListener('ended', onEnded);
          })
          .catch((err) => {
            // Manejar los errores de reproducción silenciosamente
            if (err.name !== 'AbortError') {
              console.warn('Error al reproducir video:', err.message);
            }
            // Asegurar que los botones se muestren correctamente incluso si hay error
            button.classList.remove('hidden');
            if (soundButton) {
              soundButton.classList.remove('visible');
            }
          });
      }
    },

    setupSoundButtons: function() {
      const soundButtons = document.querySelectorAll('[data-toggle-sound]');
      const self = this;

      soundButtons.forEach((button) => {
        // Limpiar event listeners creando un nuevo nodo
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);

        // Obtener referencias actualizadas
        const videoWrapper = newButton.closest('.video-wrapper');
        if (!videoWrapper) return;

        const video = videoWrapper.querySelector('video[data-video-element]');
        if (!video || !(video instanceof HTMLVideoElement)) return;

        // Inicializar el icono del sonido correctamente
        self.updateSoundButtonIcon(newButton, video);

        newButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          // Toggle muted
          video.muted = !video.muted;

          // Si el video está pausado y desmutea, reproducir
          if (video.paused && !video.muted) {
            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch((err) => {
                console.log('Error al reproducir video:', err);
              });
            }
          }

          // Actualizar icono del botón
          self.updateSoundButtonIcon(newButton, video);
        });
      });
    },

    updateSoundButtonIcon: function(button, video) {
      const svg = button.querySelector('svg');
      if (svg) {
        if (video.muted) {
          // Icono de sonido desactivado (mute)
          svg.innerHTML = '<path d="M7.727 6.313l-4.02-4.02l-1.414 1.414l18 18l1.414-1.414l-2.02-2.02A9.578 9.578 0 0 0 21.999 12c0-4.091-2.472-7.453-5.999-9v2c2.387 1.386 3.999 4.047 3.999 7a8.13 8.13 0 0 1-1.671 4.914l-1.286-1.286C17.644 14.536 18 13.19 18 12c0-1.771-.775-3.9-2-5v7.586l-2-2V2.132L7.727 6.313zM4 17h2.697L14 21.868v-3.747L3.102 7.223A1.995 1.995 0 0 0 2 9v6c0 1.103.897 2 2 2z" fill="currentColor"/>';
        } else {
          // Icono de sonido activado
          svg.innerHTML = '<path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.26 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" fill="currentColor"/>';
        }
      }
    },

    setupHoverPlayback: function() {
      const videoSlides = document.querySelectorAll('.video-slide');
      const self = this;

      videoSlides.forEach((slide) => {
        const video = slide.querySelector('video[data-video-element]');
        if (!video || !(video instanceof HTMLVideoElement)) return;

        const videoWrapper = slide.querySelector('.video-wrapper');
        const playButton = slide.querySelector('[data-toggle-play]');
        const soundButton = slide.querySelector('[data-toggle-sound]');
        if (!videoWrapper || !playButton || !soundButton) return;

        // Detectar si es escritorio (sin mouse en móvil)
        const isDesktop = window.matchMedia('(min-width: 768px)').matches;

        if (isDesktop) {
          let leaveTimeout;
          let isHovering = false;

          videoWrapper.addEventListener('mouseenter', () => {
            // Limpiar cualquier timeout pendiente
            if (leaveTimeout) {
              clearTimeout(leaveTimeout);
              leaveTimeout = null;
            }

            isHovering = true;

            // Solo reproducir si no está ya reproduciéndose
            if (video.paused) {
              // Asegurar que el video está en mute al reproducir en hover
              video.muted = true;
              // Actualizar el icono del sonido
              self.updateSoundButtonIcon(soundButton, video);
              
              const playPromise = video.play();
              if (playPromise !== undefined) {
                playPromise.catch((err) => {
                  // Ignorar silenciosamente los errores de AbortError
                  if (err.name !== 'AbortError') {
                    console.warn('Error al reproducir en hover:', err.message);
                  }
                });
              }
            }
            // Ocultar el botón de play
            playButton.classList.add('hidden');
            // Mostrar el botón de sonido
            soundButton.classList.add('visible');
          });

          videoWrapper.addEventListener('mouseleave', () => {
            isHovering = false;
            // Usar un timeout para evitar abortar la descarga demasiado rápido
            leaveTimeout = setTimeout(() => {
              if (!isHovering && !video.paused) {
                video.pause();
                video.currentTime = 0;
              }
              // Mostrar el botón de play
              playButton.classList.remove('hidden');
              // Ocultar el botón de sonido
              soundButton.classList.remove('visible');
              // Resetear muted al estado original
              video.muted = true;
              self.updateSoundButtonIcon(soundButton, video);
            }, 300); // Esperar 300ms antes de pausar
          });
        }
      });
    },

    setupEventListeners: function() {
      // Re-inicializar cuando se cargan nuevas secciones (theme editor)
      document.addEventListener('shopify:section:load', () => {
        setTimeout(() => {
          this.initializeCarousels();
          this.initLazyVideos();
          this.initPlayButtons();
        }, 100);
      });

      // Re-inicializar cuando se selecciona una sección (theme editor)
      document.addEventListener('shopify:section:select', () => {
        setTimeout(() => {
          this.initPlayButtons();
        }, 100);
      });
    }
  };

  // Inicializar cuando el DOM está listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      VideoCarousel.init();
    });
  } else {
    VideoCarousel.init();
  }

  // Exportar para uso global si es necesario
  window.VideoCarousel = VideoCarousel;
})();
